import {
  createInputFeature,
  ExtractFeaturePayload,
} from '@smartsheet-dataflow/formjs';
import { BridgeFormJSState } from '../Types';
import { dummyDispatch } from '../params/ParamFromSchema';

export const {
  actionCreator: setLinkAction,
  selectorCreator: linkSelector,
  featureReducer: LinkFeature,
} = createInputFeature<'link', LinkType>('link');

export type LinkType = string;

export type LinkState = {
  link: {
    [inputId: string]: string;
  };
};

export type LinkPayload = ExtractFeaturePayload<typeof setLinkAction>;

export const reduceLink =
  (payload: LinkPayload) => (state: BridgeFormJSState) =>
    LinkFeature(state, setLinkAction(dummyDispatch)(payload));
